import React, {useState} from "react";
import ContinueWithGoogle from "../views/ContinueWithGoogle";

function AuthModal({ setAuthModalType, type }) {
  if (type == "login") {
    return (
      <div className="h-screen w-screen">
        <ContinueWithGoogle
          onClose={() => setAuthModalType(null)}
        />
      </div>
    );
  } else if (type == "signup") {
    return (
      <div className="h-screen w-screen">
        <ContinueWithGoogle
          onClose={() => setAuthModalType(null)}
        />
      </div>
    );
  }
}

export default AuthModal;
